import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M39.019 24.07c-.003-4.314-.25-8.148-.741-11.505A3 3 0 0 0 35.31 10h-1.3a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h1.323a3 3 0 0 0 2.968-2.564c.482-3.28.72-7.069.718-11.366Zm-9.663-3.037-15.232-9.52a3.002 3.002 0 0 0-4.571 2.21c-.366 3.268-.55 6.715-.553 10.341-.002 3.606.175 7.01.532 10.212a3 3 0 0 0 4.57 2.213l15.252-9.52a3.499 3.499 0 0 0 .002-5.936Z",
      clipRule: "evenodd"
    }
  )
);
var SvgSkipNextFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SkipNextFilled_default = SvgSkipNextFilled;

export { SkipNextFilled_default as default };
